<template>
  <select class="select" @change="onChange">
    <option :selected="selectedReason === ''" :value="''">Select cancellation reason</option>
    <option
      v-for="reason in reasons"
      :key="reason"
      :value="reason"
      :selected="reason === selectedReason"
    >
      {{ reason }}
    </option>
  </select>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { TasksScreenManager } from '@/logic/TasksScreen'
import type MasterItem from '@/logic/TasksScreen/MasterItem'
import { DESIGN_CANCELLATION_REASONS } from '@/logic/TasksScreen/cancellationReasons'

@Component({})
export default class CancelDesignReasonSelect extends Vue {
  @Prop({}) action!: any
  @Prop({}) manager!: TasksScreenManager
  @Prop({}) masterItem!: MasterItem

  public selectedReason: string = ''

  get reasons() {
    return DESIGN_CANCELLATION_REASONS
  }

  get assignedReason(): string {
    return (this.masterItem?.actionData?.cancellationReason as string) || ''
  }

  @Watch('assignedReason')
  onSelectedReasonChange() {
    this.selectedReason = this.assignedReason
  }

  public onChange = (event: InputEvent) => {
    if (!this.masterItem) return
    const target = event.target as HTMLSelectElement
    this.masterItem.setActionData({
      ...this.masterItem.actionData,
      cancellationReason: target.value,
    })
  }

  mounted() {
    this.selectedReason = this.assignedReason || ''
  }
}
</script>

<style lang="scss" scoped>
.select {
  margin-right: 5px;
  font-size: 10px;
  height: 14px !important;
}
</style>
